import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

// Stale-while-revalidate cache: show last-known data instantly, refresh in the background.
const PREFIX = "rs_cache:";
const mem = new Map();

export const readCache = (path) => {
  if (mem.has(path)) return mem.get(path);
  try {
    const raw = sessionStorage.getItem(PREFIX + path);
    if (raw) { const v = JSON.parse(raw); mem.set(path, v); return v; }
  } catch (_) {}
  return undefined;
};

export const writeCache = (path, data) => {
  mem.set(path, data);
  try { sessionStorage.setItem(PREFIX + path, JSON.stringify(data)); } catch (_) {}
};

export const clearCache = () => {
  mem.clear();
  try { Object.keys(sessionStorage).filter(k => k.startsWith(PREFIX)).forEach(k => sessionStorage.removeItem(k)); } catch (_) {}
};

export const prefetch = (path) => api.get(path).then(r => { writeCache(path, r.data); return r.data; }).catch(() => {});

// Returns [data, reload, error]; data is undefined only when nothing is cached yet.
export function useCachedGet(path) {
  const [data, setData] = useState(() => readCache(path));
  const [error, setError] = useState(null);
  const reload = useCallback(() => (path ? api.get(path).then(r => { writeCache(path, r.data); setData(r.data); setError(null); return r.data; }) : Promise.resolve(undefined)), [path]);
  useEffect(() => { if (!path) return; setData(readCache(path)); setError(null); reload().catch((e) => setError(e)); }, [path, reload]);
  return [data, reload, error];
}
